import React, {Component} from 'react'
import {Collapse, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import AddressInput from "../address/AddressInput";
import addClientAddress from '../../../queries/server/mutations/add_client_address_manual'
import editClientLocalMutation from '../../../queries/client_side/mutations/edit_client'

import ClientLocationsList from "./ClientLocationsList";


class ClientLocations extends Component {

    state = {
        showInput: false,
        abode_name_no: '',
        building_no: '',
        street: '',
        city: '',
        county: '',
        postcode: '',
        name: '',
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    onChange = ({key, value}) => {
        this.setState({[key]: value})
    }

    render() {

        const {state} = this
        const {addresses, client_id} = this.props

        return (
            <div>
                <Button
                    size="sm"
                    color="success"
                    onClick={this.toggle}
                >
                    <FontAwesomeIcon color="#fff" icon="plus" />{' '}
                    Add Client Address
                </Button>

                <Mutation mutation={addClientAddress}>
                    {(addClientAddressFunc, {loading}) => (
                        <Mutation mutation={editClientLocalMutation}>
                            {(editClientLocalMutationFunc) => (
                                <AddressInput
                                    isOpen={state.showInput}
                                    toggle={this.toggle}
                                    title="Add Client Address"
                                    onChange={this.onChange}
                                    loading={loading}
                                    onValidSubmit={(address) => {
                                        addClientAddressFunc({
                                            variables: {
                                                client_id,
                                                data: [address],
                                            }
                                        })
                                        .then(({data}) => {
                                            editClientLocalMutationFunc({
                                                variables: {data: data.upsertClientAddressManual}
                                            })
                                            this.toggle();
                                            toast.success('Client Address Added', {autoClose: 2000})
                                        })
                                        .catch(e => {
                                            toast.error(e.message, {autoClose: false})
                                        })
                                    }}
                                    {...this.state}
                                />
                            )}

                        </Mutation>
                    )}

                </Mutation>

                <ClientLocationsList
                    client_id={client_id}
                    addresses={addresses}
                />
            </div>
        )
    }

}

ClientLocations.propTypes = {
    client_id: PropTypes.number.isRequired,
    addresses: PropTypes.array
}

export default ClientLocations